import React from 'react';
import { resourceBaseUrl } from '@/AppSettings';

function RejectIcon() {
    return <img src={`${resourceBaseUrl}/images/Reject.png`} className="h-auto w-fit" alt="reject" />;
}

export default RejectIcon;
